import '.bn{position:relative;}.ssr-plugin'
import '.a2{width:100%;}.ssr-plugin'
import '.gm{min-height:200px;}.ssr-plugin'
import '.g{display:flex;}.ssr-plugin'
import '.h{flex-direction:column;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.c8{align-items:flex-start;}.ssr-plugin'
import '.f{padding:2rem;}.ssr-plugin'
import '.cl{background:var(--shades-white);}.ssr-plugin'
import '.z{overflow:hidden;}.ssr-plugin'
import '.v{position:absolute;}.ssr-plugin'
import '.ia{top:50%;}.ssr-plugin'
import '.ib{right:1rem;}.ssr-plugin'
import '.ic{transform:translateY(-50%);}.ssr-plugin'
import '.id{width:120px;}.ssr-plugin'
import '.ie{height:120px;}.ssr-plugin'
import '.if{z-index:0;}.ssr-plugin'
import '.i{align-items:center;}.ssr-plugin'
import '.hx{z-index:1;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.ig{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bn a2 gm g h k c8 f cl z"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="v ia ib ic id ie if g i k"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bn hx g h c8 aj ig"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
